
      export default {
        functional: true,
        render: 
      function render(_h, _vm) {
        var _c=_vm._c;return _c('svg',{class:[_vm.data.class, _vm.data.staticClass],style:([_vm.data.style, _vm.data.staticStyle]),attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 70 70"}},[_c('path',{attrs:{"d":"M70 30H40V0H30v30H0v10h30v30h10V40h30z"}})])
      }
    
      }
    